import React, { FC, useState } from 'react';
import Header from '../Header/Header';
import Footer from '../Footer/Footer';
import TopHeader from '../Header/TopHeader';
import SideNav from '../SideNav/SideNav';
import { SideNavLayoutProvider } from './SideNavLayoutContext';
import { PageTabsProvider, usePageTabsState } from './PageTabsContext';
import { useAppSelector } from '../../redux/hooks';
import { selectTeacherOnboardingActive } from '../../redux/reducers/teacherIntroSlice';
import { useCondition } from '../../experiments/ExperimentsProvider';
import { TEAMF_824_FLAG_NAME, TEAMF_824_TREATMENT } from '../../experiments/TEAMF-824/constants';
import { useNavVersionProperty } from '../../experiments/TEAMF-824/useNavVersionProperty';
import BetaTour from '../../experiments/TEAMF-824/BetaTour';
import { hasExitedBetaNav } from '../../experiments/TEAMF-824/betaNavPreference';
import { SPEECH_STREAM_START_POINT_ID } from '../../speechstream/useSpeechStreamToolbar';
import {
  DEFAULT_CONTENT_TOP_MARGIN,
  GUIDED_TOUR_CONTENT_TOP_MARGIN,
  SIDE_NAV_GUIDED_TOUR_CONTENT_TOP_MARGIN,
} from '../../pages/guided-tour/guidedTour';

interface Props extends React.PropsWithChildren {
  hasTopBanner: boolean;
}

const StaffLayout: FC<Props> = ({ hasTopBanner, children }) => {
  const condition = useCondition(TEAMF_824_FLAG_NAME);
  const enrolled = condition === TEAMF_824_TREATMENT;
  const sideNavEnabled = enrolled && !hasExitedBetaNav();
  const [isSideNavCollapsed, setIsSideNavCollapsed] = useState(false);
  const pageTabs = usePageTabsState();
  const teacherOnboardingActive = useAppSelector(selectTeacherOnboardingActive);

  useNavVersionProperty(sideNavEnabled, enrolled);

  if (!sideNavEnabled) {
    return (
      <>
        <Header />
        <main role="main">
          <div
            className={`flex-grow-1 flex flex-column ${
              hasTopBanner ? GUIDED_TOUR_CONTENT_TOP_MARGIN : DEFAULT_CONTENT_TOP_MARGIN
            }`}
            id={SPEECH_STREAM_START_POINT_ID}
          >
            {children}
          </div>
        </main>
        <Footer canRejoinBeta={enrolled} />
      </>
    );
  }

  return (
    <SideNavLayoutProvider value>
      <PageTabsProvider value={pageTabs}>
        <div className="nc_shell">
          {!teacherOnboardingActive && (
            <SideNav isCollapsed={isSideNavCollapsed} onToggle={() => setIsSideNavCollapsed(collapsed => !collapsed)} />
          )}
          <div className="nc_shell__content">
            {!teacherOnboardingActive && <TopHeader />}
            <main role="main">
              <div
                className={`flex-grow-1 flex flex-column ${
                  hasTopBanner ? SIDE_NAV_GUIDED_TOUR_CONTENT_TOP_MARGIN : ''
                }`}
                id={SPEECH_STREAM_START_POINT_ID}
              >
                {children}
              </div>
            </main>
          </div>
          {!teacherOnboardingActive && <BetaTour />}
        </div>
      </PageTabsProvider>
    </SideNavLayoutProvider>
  );
};

export default StaffLayout;
